import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {UserTaskActivityModel, UserTaskModel} from '@/libs/Api';
import {StoreName} from '@/libs/core/store/store-name';
import { UserTasksDataService } from '../user-tasks-data-service';
import { UserTaskActivitysDataService } from '../user-task-comments-data-service';

export const tasksStore = registerCrudStore<UserTaskModel, UserTaskModel>(StoreName.UserTask, new UserTasksDataService());
export const userTaskActivitiesStore = registerCrudStore<UserTaskActivityModel, UserTaskActivityModel>(StoreName.UserTaskActivity, new UserTaskActivitysDataService());
